module.exports = __webpack_public_path__ + "static/media/neuronet.2c634b39.png";